import { render, staticRenderFns } from "./wtSlider.component.vue?vue&type=template&id=8fd1a194&scoped=true&"
import script from "./wtSlider.component.vue?vue&type=script&lang=js&"
export * from "./wtSlider.component.vue?vue&type=script&lang=js&"
import style0 from "./wtSlider.component.vue?vue&type=style&index=0&id=8fd1a194&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd1a194",
  null
  
)

export default component.exports